import { confirmable } from "react-confirm";

import type { OpenAPI } from "simplydo/interfaces";

import { createConfirmation } from "components/lib/Modal/MountPoint";

import { MergeModal } from "./IdeaMergeModal";

export const confirmMerge = (
  ideas: OpenAPI.Schemas["Idea"][],
  projectLanes: OpenAPI.Schemas["ProjectLane"][],
  challenge: OpenAPI.Schemas["Challenge"],
) =>
  createConfirmation(confirmable(MergeModal))({
    ideas,
    projectLanes,
    challenge,
  });
